import { BaseContainerModel } from '../base-container.model';
import { bl_fi_mst_entity_ext_RowInterface, bl_fi_mst_entity_event_RowInterface, bl_fi_mst_entity_line_RowInterface,
  bl_fi_mst_entity_line_RowClass } from '../../dbschema';

export class EMandateContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_line: bl_fi_mst_entity_line_RowInterface = new bl_fi_mst_entity_line_RowClass;
  bl_fi_mst_entity_exts: bl_fi_mst_entity_ext_RowInterface[] = [];
  bl_fi_mst_entity_events: bl_fi_mst_entity_event_RowInterface[] = [];
}

